export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_01.dff993f2.png";